module.exports = __webpack_public_path__ + "media/images/ultrasync-webportal_logo-c9eed6e372be8415837e5bc0999b9796.png";